import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Hashids from 'hashids'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  forceNavigate(name: string) {
    //  const hash = require('hashids');

    const hashids = new Hashids('', 3);
    const id = hashids.encode(new Date().getTime());
    this.router.navigate(['/'], { fragment: name, queryParams: { v: id.substring(0,2) } });
    //  this.router.navigate(['/'],[{fragment: name},{refresh: new Date().getTime()}])
  }

}
